import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import {
	getAllPayments,
	getPaymentsByDates,
	getPaymentsByPeriod,
} from "../../../api/apiServices";
import Pagination from "../../../services/Pagination";
import toast, { Toaster } from "react-hot-toast";
import ExcelServices from "../../../services/ExcelServices";

const PaymentReports = (props) => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/payments_reports";

	const year = new Date().getFullYear() - 5;
	const years = Array.from(new Array(20), (val, index) => index + year);
	const curr = new Date();
	curr.setDate(curr.getDate());
	var date = curr.toISOString().substring(0, 10);

	const [isDate, setIsDate] = useState(false);
	const [isMonth, setIsMonth] = useState(false);
	const [isAll, setIsAll] = useState(true);

	const [paymentsByDate, setPaymentsByDate] = useState([]);
	const [paymentsByMonth, setPaymentsByMonth] = useState([]);

	const [searchByDate, setSearchByDate] = useState({
		begin_date: date,
		end_date: date,
	});

	const [searchByMonth, setSearchByMonth] = useState({
		month: "",
		payment_year: "",
	});

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(20);

	const {
		isLoading,
		isError,
		error,
		data: payments,
	} = useQuery("payments", getAllPayments, {
		select: (data) => data.sort((a, b) => b.id - a.id),
	});
	let currentPosts = [];

	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	if (isAll) {
		currentPosts = payments?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (isDate) {
		currentPosts = paymentsByDate?.slice(indexOfFirstPage, indexOfLastPage);
	}
	if (isMonth) {
		currentPosts = paymentsByMonth?.slice(
			indexOfFirstPage,
			indexOfLastPage
		);
	}

	const handlePaymentByDate = () => {
		setIsDate(true);
		setIsMonth(false);
		setIsAll(false);
	};
	const handlePaymentByMonth = () => {
		setIsDate(false);
		setIsMonth(true);
		setIsAll(false);
	};

	const handleDateChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setSearchByDate((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleMonthChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setSearchByMonth((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleDateSearch = async (e) => {
		e.preventDefault();

		const searchDateData = {
			begin_date: searchByDate.begin_date,
			end_date: searchByDate.end_date,
		};
		searchDateMutation.mutate(searchDateData);
	};

	const searchDateMutation = useMutation(getPaymentsByDates, {
		onSuccess: async (res) => {
			if (res.success) {
				setIsDate(true);
				setIsMonth(false);
				setIsAll(false);
				setPaymentsByDate(res.payment);
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsDate(true);
				setIsMonth(false);
				setIsAll(false);
				setPaymentsByDate(null);
			}
		},

		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
		},
	});

	const handleMonthSearch = async (e) => {
		e.preventDefault();

		const searchMonthData = {
			month: searchByMonth.month,
			year: searchByMonth.payment_year,
		};
		searchMonthMutation.mutate(searchMonthData);
	};

	const searchMonthMutation = useMutation(getPaymentsByPeriod, {
		onSuccess: async (res) => {
			if (res.success) {
				setIsDate(false);
				setIsMonth(true);
				setIsAll(false);
				setPaymentsByMonth(res.payment);
			} else {
				toast.success(res.message, {
					duration: 5000,
					className: "toast-message",
				});
				setIsDate(false);
				setIsMonth(true);
				setIsAll(false);
				setPaymentsByMonth(null);
			}
		},

		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
		},
	});

	const handleCancel = () => {
		setIsDate(false);
		setIsMonth(false);
		setIsAll(true);
		navigate(from, { replace: true });
	};

	let total_amount_paid = 0;
	let paymentData = [];
	if (isDate) {
		for (var i = 0; i < paymentsByDate?.length; i++) {
			total_amount_paid += paymentsByDate[i].payment_amount;
			let monthlyData = {
				serial_no: i + 1,
				year: paymentsByDate[i].year,
				pf_number: paymentsByDate[i].pf_number,
				mobile_number: paymentsByDate[i].mobile_number,
				payment_date: paymentsByDate[i].payment_date,
				receipt_number: paymentsByDate[i].receipt_number,
				payment_type: paymentsByDate[i].payment_type,
				payment_amount: paymentsByDate[i].payment_amount,
				transaction_id: paymentsByDate[i].transaction_id,
			};
			paymentData.push(monthlyData);
		}
	}
	if (isMonth) {
		for (var j = 0; j < paymentsByMonth?.length; j++) {
			total_amount_paid += paymentsByMonth[j].payment_amount;
			let monthlyData = {
				serial_no: j + 1,
				year: paymentsByMonth[j].year,
				pf_number: paymentsByMonth[j].pf_number,
				mobile_number: paymentsByMonth[j].mobile_number,
				payment_date: paymentsByMonth[j].payment_date,
				receipt_number: paymentsByMonth[j].receipt_number,
				payment_type: paymentsByMonth[j].payment_type,
				transaction_id: paymentsByMonth[j].transaction_id,
				payment_amount: parseFloat(paymentsByMonth[j].payment_amount).toFixed(2),
			};
			paymentData.push(monthlyData);
		}
	}
	let filename = "";
	if (isDate) {
		filename = `Payment_Transactions_${searchByDate.begin_date} - ${searchByDate.end_date}.xlsx`;
	}
	if (isMonth) {
		filename = `Payment_Transactions_${searchByMonth.payment_year+searchByMonth.month}.xlsx`;
	}

	const headings = [
		[
			"SERIAL NO",
			"YEAR",
			"PF NUMBER",
			"MOBILE NUMBER",
			"PAYMENT DATE",
			"RECEIPT NUMBER",
			"PAYMENT TYPE",
			"TRANSACTION ID",
			"AMOUNT",
		],
	];

	const handleExportExcel = () => {
		ExcelServices({ headings, paymentData, filename });
	};

	const dateSearchContent = (
		<>
			<form onSubmit={handleDateSearch}>
				<div className="form-group row">
					<label htmlFor="begin_date" className="col-sm-2 label-text">
						Begin Date
					</label>
					<div className="col-sm-3">
						<input
							type="date"
							id="begin_date"
							name="begin_date"
							style={{
								height: 40,
								fontSize: 18,
							}}
							value={searchByDate.begin_date}
							onChange={handleDateChange}
							required
							className="form-control"
						/>
					</div>
					<label htmlFor="end_date" className="col-sm-2 label-text">
						End Date
					</label>
					<div className="col-sm-3">
						<input
							type="date"
							id="end_date"
							name="end_date"
							style={{
								height: 40,
								fontSize: 18,
							}}
							value={searchByDate.end_date}
							onChange={handleDateChange}
							required
							className="form-control"
						/>
					</div>
					<div className="col-sm-2">
						<button
							type="submit"
							className="btn btn-success btn-block "
						>
							{" "}
							<i className="fa fa-search"></i> Search Payments
						</button>
					</div>
				</div>
			</form>
		</>
	);

	const paymentByDateContent = (
		<>
			<button
				type="button"
				onClick={handleExportExcel}
				className="btn btn-success"
			>
				<i className="fa fa-upload"></i>&nbsp; &nbsp;Generate Excel File
			</button>
			&nbsp; &nbsp;
			<hr />
			<div className="table-responsive lg">
				<table className="table table-borderless table-striped">
					<thead>
						<tr>
							<th scope="col">#</th>
							<th scope="col">Year</th>
							<th>PF Number</th>
							<th>Mobile Number</th>
							<th scope="col">Payment Date</th>
							<th>Receipt Number</th>
							<th>Payment Type</th>
							<th>Transaction ID</th>
							<th style={{ textAlign: "right" }}>Amount Paid</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts?.map((datePayment, index) => (
							<tr key={datePayment.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{datePayment.year}</td>
								<td>{datePayment.pf_number}</td>
								<td>{datePayment.mobile_number}</td>
								<td>{datePayment.payment_date}</td>
								<td>{datePayment.receipt_number}</td>
								<td>{datePayment.payment_type}</td>
								<td>{datePayment.transaction_id}</td>
								<td style={{ textAlign: "right" }}>
									{datePayment.payment_amount.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
								</td>
							</tr>
						))}
					</tbody>
					<tbody>
						<tr>
							<th
								colSpan={"8"}
								style={{
									fontSize: 20,
									fontWeight: 600,
									color: "white",
									textTransform: "uppercase",
								}}
							>
								Total payment transactions for the period
							</th>
							<th
								style={{
									fontSize: 20,
									fontWeight: 600,
									color: "white",
									textTransform: "uppercase",
									textAlign: "right",
								}}
							>
								{total_amount_paid.toLocaleString(undefined, {
									minimumFractionDigits: 2,
								})}
							</th>
							<th></th>
						</tr>
					</tbody>
				</table>
			</div>
		</>
	);

	const monthSearchContent = (
		<>
			<form onSubmit={handleMonthSearch}>
				<div className="form-group row">
					<label
						htmlFor="payment_year"
						className="col-sm-2 label-text"
					>
						Select Year
					</label>
					<div className="col-sm-3">
						<select
							type="text"
							id="payment_year"
							autoComplete="off"
							style={{
								height: 40,
								fontSize: 18,
							}}
							name="payment_year"
							value={searchByMonth.payment_year}
							onChange={handleMonthChange}
							required
							className="form-control"
						>
							<option>Select Year</option>
							{years.map((year, index) => (
								<option value={year} key={`year${index}`}>
									{year}
								</option>
							))}
						</select>
					</div>

					<label htmlFor="month" className="col-sm-2 label-text">
						End Date
					</label>
					<div className="col-sm-3">
						<select
							type="text"
							name="month"
							id="month"
							style={{
								height: 40,
								fontSize: 18,
							}}
							required
							onChange={handleMonthChange}
							value={searchByMonth.month}
							className="form-control"
						>
							<option>Month</option>
							<option value="01">January - 01</option>
							<option value="02">February - 02</option>
							<option value="03">March - 03</option>
							<option value="04">April - 04</option>
							<option value="05">May - 05</option>
							<option value="06">June - 06</option>
							<option value="07">July - 07</option>
							<option value="08">August - 08</option>
							<option value="09">September - 09</option>
							<option value="10">October - 10</option>
							<option value="11">November - 11</option>
							<option value="12">December - 12</option>
						</select>
					</div>

					<div className="col-sm-2">
						<button
							type="submit"
							className="btn btn-success btn-block "
						>
							{" "}
							<i className="fa fa-search"></i> Search Payments
						</button>
					</div>
				</div>
			</form>
		</>
	);

	const paymentByMonthContent = (
		<>
			<button
				type="button"
				onClick={handleExportExcel}
				className="btn btn-success"
			>
				<i className="fa fa-upload"></i>&nbsp; &nbsp;Generate Excel File
			</button>
			&nbsp; &nbsp;
			<hr />
			<div className="table-responsive lg">
				<table className="table table-borderless table-striped">
					<thead>
						<tr>
							<th scope="col">#</th>
							<th scope="col">Year</th>
							<th>PF Number</th>
							<th>Mobile Number</th>
							<th scope="col">Payment Date</th>
							<th>Receipt Number</th>
							<th>Payment Type</th>
							<th>Transaction ID</th>
							<th style={{ textAlign: "right" }}>Amount Paid</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts?.map((datePayment, index) => (
							<tr key={datePayment.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{datePayment.year}</td>
								<td>{datePayment.pf_number}</td>
								<td>{datePayment.mobile_number}</td>
								<td>{datePayment.payment_date}</td>
								<td>{datePayment.receipt_number}</td>
								<td>{datePayment.payment_type}</td>
								<td>{datePayment.transaction_id}</td>
								<td style={{ textAlign: "right" }}>
									{datePayment.payment_amount.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
								</td>
							</tr>
						))}
					</tbody>
					<tbody>
						<tr>
							<th
								colSpan={"8"}
								style={{
									fontSize: 20,
									fontWeight: 600,
									color: "white",
									textTransform: "uppercase",
								}}
							>
								Total payment transactions for the period
							</th>
							<th
								style={{
									fontSize: 20,
									fontWeight: 600,
									color: "white",
									textTransform: "uppercase",
									textAlign: "right",
								}}
							>
								{total_amount_paid.toLocaleString(undefined, {
									minimumFractionDigits: 2,
								})}
							</th>
							<th></th>
						</tr>
					</tbody>
				</table>
			</div>
		</>
	);

	let content;
	if (isLoading) {
		content = <p>Loading Payment Transactions...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<div className="table-responsive lg">
				<table className="table table-borderless table-striped">
					<thead>
						<tr>
							<th scope="col" style={{ textAlign: "center" }}>
								#
							</th>
							<th scope="col" style={{ textAlign: "center" }}>
								Year
							</th>
							<th scope="col" style={{ whiteSpace: "nowrap" }}>
								PF Number
							</th>
							<th scope="col" style={{ whiteSpace: "normal" }}>
								Name
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Transaction ID
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Payment Date
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Receipt Number
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Amount Paid
							</th>
							<th
								scope="col"
								style={{
									whiteSpace: "normal",
									textAlign: "center",
								}}
							>
								Payment Mode
							</th>
							<th scope="col" style={{ textAlign: "center" }}>
								ACTION
							</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts?.map((paymt, index) => (
							<tr key={paymt.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.year}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{paymt?.pf_number}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{paymt?.members?.first_name}{" "}
									{paymt?.members?.middle_name}{" "}
									{paymt?.members?.last_name}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.transaction_id}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.payment_date}
								</td>
								<td style={{ textAlign: "center" }}>
									{paymt?.receipt_number}
								</td>
								<td style={{ textAlign: "right" }}>
									{paymt?.payment_amount.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
								</td>
								<td
									style={{
										textAlign: "center",
										whiteSpace: "nowrap",
									}}
								>
									{paymt?.payment_mode}
								</td>
								<td
									style={{
										whiteSpace: "nowrap",
										textAlign: "center",
									}}
								>
									<div style={{ display: "inline-block" }}>
										<Link
											to={`/view_payment/${paymt?.receipt_number}`}
											className="small"
										>
											<i className="fa fa-eye"></i> view
										</Link>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Payments Report </h1>
			</section>

			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<div>
												{isAll
													? "Payment Transactions"
													: isDate
													? "Payment Transactions By Date"
													: "Monthly Payment Transactions "}
											</div>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								{isDate && dateSearchContent}
								{isMonth && monthSearchContent}
								{isAll && (
									<div className="row">
										<div className="col-sm-4">
											<button
												type="button"
												className="btn btn-success btn-block"
												onClick={handlePaymentByDate}
											>
												<i className="fa fa-eye"></i>
												&nbsp; &nbsp;Payment By Date
											</button>
											&nbsp; &nbsp;
										</div>
										<div className="col-sm-4">
											<button
												type="button"
												className="btn btn-success btn-block"
												onClick={handlePaymentByMonth}
											>
												<i className="fa fa-eye"></i>
												&nbsp; &nbsp;Monthly Payment
											</button>
											&nbsp; &nbsp;
										</div>
									</div>
								)}
								{isAll && content}
								{isDate && paymentsByDate?.length > 0
									? paymentByDateContent
									: null}
								{isMonth && paymentsByMonth?.length > 0
									? paymentByMonthContent
									: null}
							</div>
							<div className="panel-footer">
								{isAll && payments?.length > 0 ? (
									<Pagination
										data={payments}
										postPerPage={postPerPage}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
										setPostPerPage={setPostPerPage}
									/>
								) : isDate && paymentsByDate?.length > 0 ? (
									<>
										<Pagination
											data={paymentsByDate}
											postPerPage={postPerPage}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
											setPostPerPage={setPostPerPage}
										/>
										<div className="search-group">
											<button
												type="button"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</>
								) : isMonth && paymentsByMonth?.length > 0 ? (
									<>
										<Pagination
											data={paymentsByMonth}
											postPerPage={postPerPage}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
											setPostPerPage={setPostPerPage}
										/>
										<div className="search-group">
											<button
												type="button"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</>
								) : null}
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
};

export default PaymentReports;
